// src/utils/boltingDemonstrationsApi.js
//
// RCSC §7 Pre-Installation Verification (PIV) — bolting demonstrations frontend API client.
// Backend deployed 2026-05-05 (Wave A); routes live but no SPA route until 2026-05-07.
// Per-tenant; references calibration_instruments.id for torque_wrench_id.

import ApiCall from "./apicall";

export const boltingDemonstrationsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return ApiCall.get(`/bolting-demonstrations${qs ? `?${qs}` : ""}`);
  },
  get: (id) => ApiCall.get(`/bolting-demonstrations/${id}`),
  create: (payload) => ApiCall.post("/bolting-demonstrations", payload),
  update: (id, payload) => ApiCall.put(`/bolting-demonstrations/${id}`, payload),
  remove: (id) => ApiCall.delete(`/bolting-demonstrations/${id}`),
};

export default boltingDemonstrationsApi;
